module.exports = __webpack_public_path__ + "img/3-.d164662f.png";